/* COPYRIGHT Esri - https://js.arcgis.com/5.1/LICENSE.txt */
const calciteContainerSizeWidthXxs = { max: "320px" };
const calciteContainerSizeWidthXs = { max: "476px" };
const calciteContainerSizeWidthSm = { max: "768px" };
const calciteContainerSizeWidthMd = { max: "1152px" };
const calciteSpacingFixedSm = "8px";
const calciteSpacingFixedMd = "12px";
const calciteSpacingFixedXl = "16px";
const calciteSpacingBase = "2px";
const calciteSpacingXxs = "0.25rem";
const calciteSpacingSm = "0.5rem";
export {
  calciteSpacingFixedMd as a,
  calciteSpacingFixedSm as b,
  calciteSpacingFixedXl as c,
  calciteContainerSizeWidthXxs as d,
  calciteContainerSizeWidthXs as e,
  calciteContainerSizeWidthSm as f,
  calciteContainerSizeWidthMd as g,
  calciteSpacingXxs as h,
  calciteSpacingBase as i,
  calciteSpacingSm as j
};
